import { showAlert } from "@sazka/design-system/src/modal-alert/mount-alert";

export const checkPlayerRestrictions = (
    hideSazkaAlert = false,
    ignoreActionId = false,
    isLottery = false
): Promise<boolean> => {
    return new Promise((res) => {
        ng_fw.getPlayerRestrictions((restrictions) => {
            const isLimited =
                !ignoreActionId &&
                restrictions.some((x) => x.actionId == 1) &&
                (!isLottery || restrictions.filter((x) => x.actionId == 1).some((x) => x.reasonId != 115));

            const isLawRestricted = restrictions.some((x) => x.reasonId == 129);

            const isRestricted = isLimited || isLawRestricted;

            if (isLawRestricted && !hideSazkaAlert) {
                showAlert({
                    title: "Omezení online hraní",
                    subText:
                        "Je nám líto, ale na základě zákona o hazardních hrách vám nadále nemůžeme umožnit online sázení na herním portálu Sazka.cz. Výběry z vašeho účtu jsou možné.",
                    btnConfirmText: "Více informací",
                    btnConfirmHref: "/centrum-podpory/online-hrani-na-sazka-cz/muj-ucet/rejstrik-vyloucenych-osob",
                    btnCloseText: "Rozumím",
                    btnCloseType: "secondary",
                    buttonsFlexDirection: "row",
                    isWide: true,
                    animate: true,
                });
            } else if (isLimited && !hideSazkaAlert) {
                showAlert({
                    title: "Sázka neproběhla",
                    subText:
                        "Je nám líto, ale vámi zvolenou sázku se nepodařilo uzavřít s ohledem na aktuální omezení na vašem účtu. Pro více informací se obraťte na naše kontaktní centrum. ",
                    btnCloseText: "Rozumím",
                });
            }

            res(isRestricted);
        });
    });
};
